<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Formatos</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Formatos</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <form [formGroup]="formBusqueda">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
        <button type="button" mdbBtn color="info" (click)="showForNew();agregarFormato.show()" size="sm" mdbWavesEffect>
          Agregar
        </button>
      </div>


      <div class="row filtros-body">

        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <input value="" type="text" id="codigo" class="form-control" placeholder="0000" required
              formControlName="codigo" #codigo />
            <label for="codigo">Código</label>
          </div>
        </div>



      </div>

    </div>
  </form>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
    <div></div>
    <button mdbBtn color="secondary" size="sm" mdbWavesEffect (click)="buscaFormato()">
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>

            <th scope="col">Nombre</th>
            <th scope="col">Código</th>
            <th scope="col">Cantidad</th>
            <th scope="col">Venta</th>
            <th scope="col">Compra</th>
            <!-- <th scope="col" >Formato Padre</th> -->
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let forma of formatoList">

            <td>{{ forma.nombre }}</td>
            <td>{{ forma.codigo }}</td>
            <td>{{ forma.cantidad }}</td>
            <td>
              <div *ngIf="forma.es_venta">
                <mdb-badge pill="true" success="true">Si</mdb-badge>
              </div>
              <div *ngIf="!forma.es_venta">
                <mdb-badge pill="false" warning="true">No</mdb-badge>
              </div>
            </td>
            <td>
              <div *ngIf="forma.es_compra">
                <mdb-badge pill="true" success="true">Si</mdb-badge>
              </div>
              <div *ngIf="!forma.es_compra">
                <mdb-badge pill="false" warning="true">No</mdb-badge>
              </div>
            </td>
            <!-- <td>
    <mdb-select
      [options]="optionsFormatoPadre"
      placeholder="Formato"
      [filterEnabled]="true"
    ></mdb-select>
  </td> -->
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                mdbTooltip="Editar" placement="right" (click)="agregarFormato.show();showForEdit(forma)">
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
            </td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar Formato-->
<div mdbModal style="overflow-y: auto" #agregarFormato="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form [formGroup]="formFormato">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="agregarFormato.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Datos del Formato
                </h5>
              </div>
            </div>

            <div class="row filtros-body">
              <div class="col">
                <div class="md-form">
                  <input type="hidden" id="esEdicion" value="" name="esEdicion" formControlName="esEdicion" />
                  <input value="" type="text" id="codigo" class="form-control" placeholder="Código" required #ncodigo
                    formControlName="codigo" maxlength="5" />
                  <label for="ncodigo">Código</label>
                  <div *ngIf="
                    f.codigo.invalid &&
                    (f.codigo.dirty || f.codigo.touched)
                  ">
                    <mdb-error *ngIf="f.codigo.errors.required">
                      El código es requerido
                    </mdb-error>
                    <mdb-error *ngIf="f.codigo.errors.maxlength">
                      El código no puede superar los 5 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="f.codigo.errors.minlength">
                      El código debe tener como mínimo 2 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input value="" type="text" id="nombre" class="form-control" placeholder="Formato de venta $" required
                    #nombre formControlName="nombre" />
                  <label for="nombre">Nombre</label>
                  <div *ngIf="
                    f.nombre.invalid &&
                    (f.nombre.dirty || f.nombre.touched)
                  ">
                    <mdb-error *ngIf="f.nombre.errors.required">
                      El nombre es requerido
                    </mdb-error>
                    <mdb-error *ngIf="f.nombre.errors.maxlength">
                      El nombre no puede superar los 20 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="f.nombre.errors.minlength">
                      El nombre debe tener como mínimo 2 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input value="" type="text" id="cantidad" class="form-control" placeholder="Cantidad" required
                    #cantidad type="number" formControlName="cantidad" />
                  <label for="cantidad">Factor</label>
                  <div *ngIf="
                    f.cantidad.invalid &&
                    (f.cantidad.dirty || f.cantidad.touched)
                  ">
                    <mdb-error *ngIf="f.cantidad.errors.required">
                      La cantidad es requerida
                    </mdb-error>
                  </div>
                </div>

                <!-- Material inline 1 -->
                <mdb-checkbox [inline]="true" formControlName="esVenta">Formato de Venta</mdb-checkbox>

                <!-- Material inline 2 -->
                <mdb-checkbox [inline]="true" formControlName="esCompra">Formato de Compra</mdb-checkbox>


              </div>
            </div>




          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="agregarFormato.hide()"
            mdbWavesEffect>
            Cerrar
          </button>
          <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect type="button"
            [disabled]="!formFormato.valid" (click)="ValidaQueExisteDatosFormato(); agregarFormato.hide()">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- MODAL seleccionarCliente -->
<div mdbModal #seleccionarCliente="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar cliente
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="seleccionarCliente.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="nombreProduct" class="form-control" placeholder="Nombre o RUT del cliente"
                required #nombreProduct />
              <label for="nombreProduct">Nombre o RUT del cliente</label>
            </div>
          </div>
          <div class="col" style="width: 50px">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="seleccionarCliente.show()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
          </div>
        </div>
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" class="text-center" class="text-center">RUT</th>
              <th scope="col" class="text-center" class="text-center">
                Nombre
              </th>
              <th scope="col" class="text-center" class="text-center">
                Sucursal
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre cliente</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarCliente.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre cliente</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarCliente.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre cliente</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarCliente.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarVendedor -->
<div mdbModal #seleccionarVendedor="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar vendedor
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="seleccionarVendedor.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="rutVend" class="form-control" placeholder="Nombre o RUT del vendedor"
                required #rutVend />
              <label for="rutVend">Nombre o RUT del vendedor</label>
            </div>
          </div>
          <div class="col" style="width: 50px">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="seleccionarVendedor.show()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
          </div>
        </div>
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" class="text-center">RUT</th>
              <th scope="col" class="text-center">Nombre</th>
              <th scope="col" class="text-center">Sucursal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarVendedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarVendedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarVendedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
